import { useQuery } from '@tanstack/react-query'

import { CombinationItemViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'

import { PLPReactQueryKeys } from '../types'

interface Props {
    cat_id: string
}

export function useGetCombinationsList({ cat_id }: Props) {
    return useQuery<unknown, unknown, CombinationItemViewModel[]>({
        queryKey: [PLPReactQueryKeys.CombinationsList, { cat_id }],
        queryFn: () => {
            return fetchRequest({
                endpoint: `/combinations/category/${cat_id}`,
                method: 'GET',
                serviceName: 'cml',
            })
        },
        enabled: !!cat_id,
    })
}
